<template>
<div id="clientes_referencias">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Plantas/Referencias" class="elevation-1 px-5 py-3">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-speed-dial direction="left" open-on-hover>
              <template v-slot:activator>
                <v-btn x-small fab dark color="primary">
                  <v-icon>reorder</v-icon>
                </v-btn>
              </template>
              <exportar-excel :data="datafiltered" :exportFields="referencias.camposexcel" name="Referencias.xlsx">
                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                  <v-icon dark>get_app</v-icon>
                </v-btn>
              </exportar-excel>
            </v-speed-dial>

            <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
              <v-icon dark>add</v-icon>
            </v-btn>

            <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;">
              <v-card>
                <v-card-title>
                  <v-card class="primary white--text titulomodal">
                    <v-icon class="white--text">{{
                        update ? "edit" : "add"
                      }}</v-icon>&nbsp;
                    <span class="subheading">
                      <strong>{{ update ? "Actualizar" : "Nueva" }} Planta/Referencia</strong>
                    </span>
                  </v-card>
                  <v-spacer></v-spacer>
                  <v-btn icon @click.native="modal = false" class="close_modal">
                    <v-icon class="white--text">cancel</v-icon>
                  </v-btn>
                </v-card-title>
                <v-form ref="form" lazy-validation>
                  <v-card-text>
                    <v-container grid-list-md text-xs-center @keyup.enter="guardar()">
                      <v-layout row wrap>
                        <v-flex s12 m4 l4>
                          <v-text-field label="Planta/Referencia" type="text" v-model="model.referencia" v-on:keydown.enter.prevent='1' @input="model.referencia = model.referencia.toUpperCase()" :rules="[rules.required]"
                            maxlength="250">
                          </v-text-field>
                          <v-flex s12 m4 l4>
                            <v-text-field label="Nombre" type="text" v-model="model.nombre" v-on:keydown.enter.prevent='1' maxlength="250"></v-text-field>
                          </v-flex>
                          <v-flex s12 m4 l4>
                            <v-text-field label="RFC" type="text" v-model="model.rfc" v-on:keydown.enter.prevent='1' maxlength="15" @input="model.rfc = model.rfc.toUpperCase()"></v-text-field>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-form>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click.native="modal = false">
                    <v-icon>cancel</v-icon> Cancelar
                  </v-btn>
                  <v-btn color="success" :loading="loading" @click.native="guardar()">
                    <v-icon>done</v-icon>
                    {{ update ? "Actualizar" : "Guardar" }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-actions>

          <v-card-text>
            <div id="datagrid">

              <v-client-table ref="vuetable" :data="referencias.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontró ningun registro</v-alert>
                </template>

                <template slot="actions" slot-scope="props">
                  <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                    <template v-slot:activator>
                      <v-btn :id="props.row.id" x-small fab dark color="primary">
                        <v-icon>reorder</v-icon>
                      </v-btn>
                    </template>

                    <v-btn x-small fab dark color="blue" @click.native="
                          getRegistro(props.row.id)
                        " title="Editar Registro" v-tippy>
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id)
                        " title="Eliminar Registro" v-tippy>
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-speed-dial>
                </template>
              </v-client-table>
            </div>
          </v-card-text>
        </base-material-card>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
import axios from "axios";
import GridLoader from "vue-spinner/src/GridLoader.vue";
export default {
  components: {
    loader: GridLoader
  },

  data: () => ({
    columns: [
      "referencia",
      "nombre",
      "rfc",
      "actions"
    ],
    show_loading: true,
    options: {
      filterable: [
        "referencia",
        "nombre",
        "rfc"
      ],
      sortable: [
        "referencia",
        "nombre",
        "rfc"
      ],

      headings: {
        referencia: "Planta/Referencia",
        nombre: "Nombre",
        rfc: "RFC",
        actions: "Operaciones"
      },
    },
    URL: "",
    show_loading: true,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Utilerías",
        disabled: true,
        to: ""
      },
      {
        text: "Plantas/Referencias",
        disabled: true,
        to: ""
      }
    ],
    loading: false,
    title: "",
    modal: false,
    update: false,
    model: {
      id: 0,
      referencia: "",
      cliente: 0,
      nombre:"",
      rfc:""
    },
    rules: {
      required: v => !!v || "Este campo es requerido",
    },
    referencias: {
      selected: [],
      camposexcel: {
        Referencia: "referencia",
      },
      items: [],
    },
  }),
  computed: {
    datafiltered() {
      if (this.$refs.vuetable != null) {
        return this.$refs.vuetable.allFilteredData;
      } else {
        return this.referencias.items;
      }

    },
  },
  methods: {
    openModal: function(type) {
      if (type === 1) {
        this.limpiarModel();
        this.title = "Nueva Referencia";
        this.update = false;
      } else {
        this.title = "Actualizar Referencia";
        this.update = true;
      }
      this.modal = true;
    },

    limpiarModel: function() {
      for (var k in this.model) {
        this.model[k] = "";
      }
      this.model.cliente = this.$local_storage.get("id_cliente");
    },

    guardar() {
      const datos = {
        id: this.model.id,
        referencia: this.model.referencia,
        cliente: this.$local_storage.get("id_cliente"),
        nombre: this.model.nombre,
        rfc: this.model.rfc
      };

      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var metodo = "post";
        var urlCliente = this.URL;
        if (this.update == true) {
          metodo = "put";
          urlCliente += this.model.id + "/";
        }
        axios({
            method: metodo,
            url: urlCliente,
            data: datos
          })
          .then(res => {
            this.$swal({
              type: "success",
              title: "¡Operación Exitosa!",
              text: "Los datos se guardaron correctamente",
              footer: ""
            });
            this.$root.$dialogLoader.hide();
            this.modal = false;
            this.cargar();
          })
          .catch(error => {
            var mensaje = "";
            if (error.response != undefined && error.response.data != undefined) {
              for (var k in error.response.data) {
                mensaje += error.response.data[k].toString();
              }
            }
            this.$swal({
              position: "center",
              type: "error",
              title: "¡Operación no Permitida!",
              text: "Ocurrió un error al guardar los datos",
              footer: mensaje,
              //showConfirmButton: false,
            });
            this.$root.$dialogLoader.hide();
            this.modal = false;
          });
      }
    },

    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        cliente: this.$local_storage.get("id_cliente")
      };
      axios
        .post(this.URL + "get_referencias/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.referencias.items = res.data;
            this.$root.$dialogLoader.hide();
          }
        })
        .catch(err => {
          console.log(err);
          this.$root.$dialogLoader.hide();
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },

    getRegistro: function(id_registro) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      axios
        .get(this.URL + id_registro + "/")
        .then(response => {
          this.model = response.data;
          this.openModal(2); //ACTUALIZAR
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener el registro",
            footer: ""
          });
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    }, //getRegistro

    deleteRegistro: function(id_registro) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el registro?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          axios.delete(this.URL + id_registro + "/")
            .then(response => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El registro se eliminó correctamente.",
                //position: 'bottom-end',
                //timer: 3000,
                //showConfirmButton: false,
                footer: ""
              });
            })
            .catch(error => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el registro",
                footer: ""
              });
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargar();
            });
        }

      });
    },

  }, //methods
  created: function() {
    this.URL = this.$hostname + "catalogos/referencias/";
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.cargar();
  }
};
</script>
